<div class="flex-1 flex flex-col overflow-auto">
  <!-- Dashboard Content -->
  <main
    class="flex-1 overflow-y-auto p-6"
    style="min-height: 0; -webkit-overflow-scrolling: touch"
  >
    @if (loadingDashboard) {
      <!-- Loading State -->
      <div class="flex items-center justify-center min-h-[400px]">
        <app-loader 
          type="inline" 
          message="Loading dashboard data..." 
          size="large"
          ariaLabel="Loading dashboard data">
        </app-loader>
      </div>
    } @else {
      <!-- Summary Cards -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        @for (card of summaryCards; track card.title) {
        <app-summary-card [data]="card"></app-summary-card>
        }
      </div>

      <!-- Notification Demo Button -->
      <!-- <div class="mb-6 text-center">
          <button
            (click)="addSampleNotification()"
            class="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg transition-colors duration-200"
          >
            📢 Add Sample Notification
          </button>
          <p class="text-sm text-gray-600 mt-2">
            Click to see the notification system in action. Check the bell icon in the header!
          </p>
        </div> -->

      <!-- Tables Section -->
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        <!-- Recent Letters Table -->
        <app-dashboard-table
          [data]="recentLetters"
          [config]="lettersTableConfig"
          type="documents"
          (documentNameClick)="onDocumentNameClick($event)"
        ></app-dashboard-table>

        <!-- Recent Routing Slip Table -->
        <app-dashboard-table
          [data]="recentRoutingSlip"
          [config]="routingSlipTableConfig"
          type="documents"
          (documentNameClick)="onRoutingSlipDocumentClick($event)"
        ></app-dashboard-table>
      </div>

      <!-- Users Table Section (Admin Only) -->
      @if (isAdmin) {
      <div class="mb-6">
        <app-dashboard-table
          [data]="recentUsers"
          [config]="usersTableConfig"
          type="users"
        ></app-dashboard-table>
      </div>
      }
    }
  </main>

  <!-- Footer -->
  <!-- <footer class="bg-white border-t border-gray-200 py-4">
    <div class="text-center text-sm text-gray-600">
      Copyright © 2012 - 2025 NITI. All Rights Reserved.
    </div>
  </footer> -->

  <!-- Document Viewer Modal -->
  <app-document-viewer-modal
    [(visible)]="showDocumentViewer"
    [attachment]="currentDocument"
    [loading]="documentLoading"
    (visibleChange)="showDocumentViewer = $event"
    (download)="onDocumentDownload($event)"
    (openInNewTab)="onDocumentOpenInNewTab($event)"
    (close)="onDocumentViewerClose()"
  ></app-document-viewer-modal>

  <!-- Toast Messages -->
  <p-toast position="top-right"></p-toast>
</div>
